import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Employers } from './pages/Employers';
import { Candidates } from './pages/Candidates';
import { Contact } from './pages/Contact';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2riko97zkgfcl">
      <Routes data-id="element-1" data-mp="2mm2lgdnsqr2w">
        <Route element={<SiteLayout data-id="element-3" data-mp="2mmvk0rclqa9y" />} data-id="element-2" data-mp="2mmlt91jqfz37">
          <Route path="/" element={<Home data-id="element-5" data-mp="2mjzplczyq3q9" />} data-id="element-4" data-mp="2mnnhy8to8k3e" />
          <Route path="/about" element={<About data-id="element-7" data-mp="31bibfrfi6shj" />} data-id="element-6" data-mp="31b8j3x6zk98o" />
          <Route path="/services" element={<Services data-id="element-9" data-mp="2wk06ksad07ra" />} data-id="element-8" data-mp="31c1jmgfcq2id" />
          <Route path="/employers" element={<Employers data-id="element-11" data-mp="2wifc12o1ootf" />} data-id="element-10" data-mp="2wjqg73lejyl2" />
          <Route path="/candidates" element={<Candidates data-id="element-13" data-mp="28tmfp53igeya" />} data-id="element-12" data-mp="2wi5m1f302hnq" />
          <Route path="/contact" element={<Contact data-id="element-15" data-mp="28s2xh8yanttv" />} data-id="element-14" data-mp="28suu8n3mnxlq" />
          <Route path="*" element={<NotFound data-id="element-17" data-mp="23u9uspw79hyc" />} data-id="element-16" data-mp="23vkzcrxgytqi" />
        </Route>
      </Routes>
    </BrowserRouter>;
}